import * as t from "react";
const i = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 4, fill: "none", ...e }, /* @__PURE__ */ t.createElement("rect", { width: 32, height: 4, fill: "#E4E4E4", rx: 2 }));
export {
  i as default
};
